module.exports = __webpack_public_path__ + "img/zh-CN.03b8b2c0.png";